module.exports = __webpack_public_path__ + "static/owlbear-abbd35816ce5792633f5214c23a7bcf0.jpg";